import React from "react";

function Footer() {
  return (
    <div className="footer">
      <footer className="py-5 bg-dark fixed-bottom">
        <div className="container">
          <p className="m-0 text-center text-white">
            Copyright &copy; Easy Coding 2022
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
